import { ajaxSend } from '../../../api/api';

import {
  DashboardQueueApiQueryParams,
  DashboardQueueIdsApiQueryParams,
  DashboardQueueResponsePayload,
} from './types';

export const basePath = '/v2/statistics';
export const baseQueuePath = `${basePath}/dashboard/queue`;
export const baseAgentQueuePath = `${basePath}/dashboard/agent/queue`;

/**
 * Gets search params from an API path.
 *
 * @param path The path.
 */
export function apiPathToSearchParams<T extends Record<string, unknown>>(
  path: string,
): T {
  const searchParams = path.split('?').pop();

  return Array.from(new URLSearchParams(searchParams).entries()).reduce(
    (acc, [key, value]) => ({ ...acc, [key]: value }),
    {} as T,
  );
}

/**
 * Gets dashboard queues.
 *
 * @param params The dashboard queue query params.
 */
export async function getAllQueues(params: DashboardQueueApiQueryParams) {
  const path = `${baseQueuePath}?${new URLSearchParams(
    params as Record<string, string>,
  )}`;

  const data = await ajaxSend<DashboardQueueResponsePayload>({ path });
  data.meta.current_page = path;
  return data;
}

/**
 * Gets dashboard agent queues.
 *
 * @param params The dashboard queue query params.
 */
export async function getAgentQueues(params: DashboardQueueApiQueryParams) {
  const path = `${baseAgentQueuePath}?${new URLSearchParams(
    params as Record<string, string>,
  )}`;

  const data = await ajaxSend<DashboardQueueResponsePayload>({ path });
  data.meta.current_page = path;
  return data;
}

/**
 * Gets queues by their id's.
 *
 * @param queueIds The string array of queue id's.
 * @param sortBy The sort_by string.
 */
export function getQueuesById(params: DashboardQueueIdsApiQueryParams) {
  return ajaxSend<DashboardQueueResponsePayload>({
    path: baseQueuePath,
    params,
  });
}

/** @deprecated See TEAMS-4114 */
const v1BasePath = '/v1/statistics';

/**
 * Gets all available queues from the v1 dashboard queue endpoint.
 *
 * @deprecated See TEAMS-4114
 */
export function getAllQueuesV1() {
  return ajaxSend({
    path: `${v1BasePath}/dashboard/queue`,
  });
}

/**
 * Gets all available agent queues from the v1 dashboard agent queue endpoint.
 *
 * @deprecated See TEAMS-4114
 */
export function getAgentQueuesV1() {
  return ajaxSend({
    path: `${v1BasePath}/dashboard/agent/queue`,
  });
}
